import { YieldCurveValuesType } from '@/enums/scenario-builder.enum'
import { YieldCurveTypeOptionsProps } from '@/interfaces/scenarioBuilder.interface'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import React from 'react'

export const YieldCurveTypeOptions: React.FC<YieldCurveTypeOptionsProps> = ({
  value,
  disabled = false,
  onChange,
  showLabel = true,
}) => {
  return (
    <FormControl>
      <RadioGroup
        row
        aria-labelledby='demo-row-radio-buttons-group-label'
        name='row-radio-buttons-group'
        defaultValue={YieldCurveValuesType.PAR}
        value={value}
        onChange={onChange}
        data-cy='yield-curve-type-group'
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 1,
        }}
      >
        {showLabel && <label>Yield Curve Type: </label>}
        <FormControlLabel
          value={YieldCurveValuesType.PAR}
          control={
            <Radio data-cy='yield-curve-par-radio' disabled={disabled} />
          }
          label='Par'
        />
        <FormControlLabel
          value={YieldCurveValuesType.SPOT}
          control={
            <Radio data-cy='yield-curve-spot-radio' disabled={disabled} />
          }
          label='Spot'
        />
      </RadioGroup>
    </FormControl>
  )
}
